import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { Alert } from 'react-bootstrap';
import { Pb3, Pb4 } from '../../../components/P';
import { Button, Result } from 'antd';
import { useGet } from '../../../hooks/localSchedule/useGet';
import { useExtend } from '../../../hooks/localSchedule/useExtend';
import { CART_HOLD_MINUTES } from '../../../hooks/localSchedule/useAdd';
import SelectedSchedulesTrigger from './SelectedSchedulesTrigger';

dayjs.extend(duration);

// Offer more time once the timer gets this low.
const EXTEND_THRESHOLD_MS = 5 * 60 * 1000;

const SavedSchedulling = () => {
  const schedule = useGet();
  const extend = useExtend();
  const [remainingMs, setRemainingMs] = useState(() =>
    schedule ? Math.max(dayjs(schedule.validTo).diff(dayjs()), 0) : 0
  );

  // When the schedule changes, set the initial remaining time.
  useEffect(() => {
    if (schedule) {
      const diff = dayjs(schedule.validTo).diff(dayjs());
      setRemainingMs(diff > 0 ? diff : 0);
    }
  }, [schedule]);

  // Update the remaining time every second.
  useEffect(() => {
    if (!schedule) return;
    const interval = setInterval(() => {
      const diff = dayjs(schedule.validTo).diff(dayjs());
      if (diff <= 0) {
        // When expired, just set remaining time to zero.
        setRemainingMs(0);
        clearInterval(interval);
        // No need to manually clear the schedule here since useGetSchedule handles it.
      } else {
        setRemainingMs(diff);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [schedule]);

  // If there's no schedule or there are no selections, don't render anything.
  if (!schedule || !schedule.selections?.length) {
    return null;
  }

  // Format the remaining time.
  const remainingDuration = dayjs.duration(remainingMs);
  const minutes = remainingDuration.minutes();
  const seconds = remainingDuration.seconds();

  return (
    <>
      <Pb3>
        <Alert style={{ padding: 0 }} variant="success">
          <Result
            status="success"
            title={`You have ${minutes.toString().padStart(2, '0')}:${seconds
              .toString()
              .padStart(2, '0')} left`}
            subTitle={
              <>
                Make changes to, or finalize this schedule.
                <br />
                Your selections will be cleared when the timer runs out. Spots
                are not held until you finalize.
              </>
            }
            extra={[
              ...(remainingMs < EXTEND_THRESHOLD_MS
                ? [
                    <Button
                      key="extend"
                      data-testid="extend-cart-button"
                      onClick={extend}
                    >
                      {`Add ${CART_HOLD_MINUTES} minutes`}
                    </Button>,
                  ]
                : []),
              <SelectedSchedulesTrigger
                buttonLabel="View Your Schedule"
                dataTestId="saved-schedule-trigger-button"
                key="view"
                variant="text"
              />,
            ]}
          />
        </Alert>
      </Pb3>

      <Pb4>
        <hr />
      </Pb4>
    </>
  );
};

export default SavedSchedulling;
